module.exports = __webpack_public_path__ + "static/media/cafe24-item-sub2.873bded7.png";